import { render, staticRenderFns } from "./pdamoduleaccess.vue?vue&type=template&id=1dd04d04"
import script from "./pdamoduleaccess.vue?vue&type=script&lang=js"
export * from "./pdamoduleaccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports